module.exports = __webpack_public_path__ + "static/forecast/windstock/strong-fe086d1dbb0e9d1e3907ac89b9252c7f.svg";